<template>
  <div class="self-advantage">
    <div
      class="le-img"
      :style="{
        backgroundImage: 'url(' + dataInfo.icon + ')'
      }"
    ></div>
    <div
      class="ri-img"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    ></div>
    <div class="g-box">
      <div class="inner">
        <div class="le ">
          <div class="en">{{ dataInfo.tips }}</div>
          <div class="zh">{{ dataInfo.name }}</div>
        </div>
        <div class="ri">
          <div class="items">
            <div class="item" v-for="item in dataList" :key="item.id">
              <div class="tt">{{ item.title }}</div>
              <div class="subtt">
                {{ item.subtitle }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 999,
      menuId: this.menuId
    });
    this.dataInfo = dataInfo;
    this.dataList = data;
  },
  methods: {}
};
</script>
<style lang="less">
.self-advantage {
  position: relative;
  padding-top: 80px;
  height: 710px;
  background: #000;
  box-sizing: border-box;
  .le-img {
    position: absolute;
    left: 0;
    bottom: 0;
    content: "";
    width: 460px;
    height: 300px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .ri-img {
    position: absolute;
    right: 0;
    bottom: 0;
    content: "";
    width: 360px;
    height: 540px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .inner {
    display: flex;
    .le {
      margin-right: 160px;

      .en {
        font-size: 72px;
        font-family: "en-tit";
        color: #fff;
      }
      .zh {
        font-size: 48px;
        font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
        font-weight: 800;
        color: #fff;
      }
    }
    .ri {
      .items {
        .item {
          width: 350px;
          margin-bottom: 30px;
          .tt {
            font-size: 22px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #2c6fff;
          }
          .subtt {
            padding-top: 16px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            word-break: break-all;
            line-height: 28px;
          }
        }
        .item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
